import React, {useState} from "react";
import Subsearch from "../Subsearch";
import GridView from "../GridView";
import ListView from "../ListView";

const SearchResults = (props) => {
    const [selectedType, setSelectedType] = useState("grid");

    const [filters, setFilters] = useState();

    let gridViewClass = "view-type" + (selectedType === 'grid' ? ' selected' : "");
    let listViewClass = "view-type" + (selectedType === 'list' ? ' selected' : "");
    let floorViewClass = "view-type" + (selectedType === 'floor_plan' ? ' selected' : "");

    const filterResults = (filters) => {
        setFilters(filters)
    }

    let results = []
    props.searchResults && filters && Object.keys(filters).forEach(type => {
        let typeResults = props.searchResults.filter (r => r.type === type);
        filters[type].forEach(e => {
            let elements = typeResults.filter(r => r.id == e.id)
            console.log(elements)
            if (elements.length) results = results.concat(elements)
        })
    })

    return (
        <div className="search-results">
            <div className="view-chooser">
                <div className="search-term">SHOWING RESULTS FOR "{props.searchTerm}"</div>
                <Subsearch searchResults={props.searchResults} callback={filterResults}/>
                <div className="view-types">
                    <div className={gridViewClass} onClick={() => { setSelectedType("grid") }}>Grid</div>
                    <div className={listViewClass} onClick={() => { setSelectedType("list") }}>List</div>
                    <div className={floorViewClass} onClick={() => { setSelectedType("floor_plan")}}>Floor Plan</div>
                </div>
            </div>
            {
                selectedType === "grid" ?
                    <GridView searchResults={ results.length ? results : props.searchResults } /> : selectedType === "list" ?
                    <ListView searchResults={ results.length ? results : props.searchResults } /> : null
            }
        </div>

    )
        

}

export default SearchResults;